import React, { memo, useContext } from "react";
import { getRemovableCoupon, useCouponCode } from "hooks/useCouponCode";
import CouponImage from "assets/CouponImage.png";
import SuccessCoupon from "assets/SuccessCoupon.png";
import { Box, InputAdornment, TextField } from "@mui/material";
import {
  CouponTitle,
  ApplyCouponName,
  ApplyCouponRemove,
  ApplyCouponWrapper,
  CouponSubmitButton,
  ApplyCouponStartInfo,
  HelperText,
} from "components/styles";
import { TOContext } from "context/TContext";

const getAppliedCouponTitle = (coupon) =>
  coupon?.couponTitle ||
  coupon?.couponName ||
  coupon?.displayLabel ||
  coupon?.promotionName ||
  coupon?.couponCode ||
  coupon?.promotionCode ||
  "";

const getAppliedCouponCode = (coupon) =>
  coupon?.couponCode || coupon?.promotionCode || "";

const TOCoupon = ({ bId, oId }) => {
  const { isRefundDueShow } = useContext(TOContext);
  const {
    couponCode,
    handleChangeCouponCode,
    handleSubmitCouponCode,
    loadingCoupon,
    appliedCoupons,
    handleRemoveCoupon,
    loadingRemoveCoupon,
    error,
  } = useCouponCode(bId, oId);

  return (
    <>
      <CouponTitle>Enter Coupon Code (if any)</CouponTitle>
      <Box sx={{ display: "flex", mb: appliedCoupons.length ? 0 : 3 }}>
        <TextField
          id="standard-error-helper-text"
          name="couponCode"
          label={"Coupon Code"}
          size="middle"
          value={couponCode}
          disabled={isRefundDueShow}
          fullWidth
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "& .MuiOutlinedInput-notchedOutline": {
                borderRight: "none",
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
              },
            },
          }}
          onChange={handleChangeCouponCode}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <img src={CouponImage} alt="start icon" />
              </InputAdornment>
            ),
          }}
        />
        <CouponSubmitButton
          onClick={handleSubmitCouponCode}
          variant="contained"
          loading={loadingCoupon}
          disabled={loadingCoupon || !couponCode}
        >
          APPLY
        </CouponSubmitButton>
      </Box>
      {error && <HelperText>{error}</HelperText>}
      {appliedCoupons.map((coupon, index) => {
        const title = getAppliedCouponTitle(coupon);
        const code = getAppliedCouponCode(coupon);
        const showCode = Boolean(code && title && code !== title);
        const removableCoupon = getRemovableCoupon(coupon);

        return (
          <ApplyCouponWrapper
            key={
              coupon?.uuid ||
              coupon?.promotionUuid ||
              coupon?.couponId ||
              coupon?.couponCode ||
              index
            }
          >
            <ApplyCouponStartInfo>
              <img src={SuccessCoupon} alt="success" />
              <Box>
                <ApplyCouponName>{title}</ApplyCouponName>
                {showCode && (
                  <ApplyCouponName sx={{ mt: "2px" }}>{code}</ApplyCouponName>
                )}
              </Box>
            </ApplyCouponStartInfo>
            {removableCoupon && (
              <ApplyCouponRemove
                loading={`${loadingRemoveCoupon}`}
                disabled={loadingRemoveCoupon}
                onClick={() => handleRemoveCoupon(coupon)}
              >
                Remove
              </ApplyCouponRemove>
            )}
          </ApplyCouponWrapper>
        );
      })}
    </>
  );
};

export default memo(TOCoupon);
